import { DragNDropChipable } from "../components/drag-n-drop-chips/drag-n-drop-chips.component";
import { BaseModel, BaseWithId } from "./base";
import { Filter } from "./filter";

export class Widget extends BaseWithId {
    
    public user_id: string;

    public name: string;
    public label: string;
    public service: string;
    
    public shortDescription: string;
    public longDescription: string;
    
    public applications: [];
    
    public urlMetadata: string;
    public urlData: string;
    public position: number;
    public enabled: boolean;
    
    public settings: WidgetSettings;
    public subWidgets: Widget[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            settings: json.settings ? new WidgetSettings(json.settings) : null,
            subWidgets: json.subWidgets ? json.subWidgets.map((widget) => new Widget(widget)) : []
        });
    }
}

export class WidgetSettings extends BaseModel {
    public columns: WidgetColumn[];
    public filters: WidgetFilter;
    public linesPerPage: number;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            columns: json && json.columns ? json.columns.map((column: any) => new WidgetColumn(column)) : [],
            filters: json && json.filters ? new WidgetFilter(json.filters) : new WidgetFilter()
        });
    }
}

export class WidgetFilter extends BaseModel {

    [index: string]: any;

    constructor(json?: any) {
        super(json);
    }

    get filters(): Filter[] {
        return Object.keys(this).map((key: string) => {
            return new Filter({
                'id': key,
                'value': this[key]
            })
        });
    }
}

export class WidgetColumn extends BaseWithId implements DragNDropChipable {
    
    public type: string;
    public label: string;
    public sortable: boolean;
    public sort_order: number;
    
    get displayName() {
        return 'case_widget.column.' + this.label; // TODO: translate?
    }

    get notSortable(): boolean {
        return false;
    }

    get notSelectable(): boolean {
        return false;
    }

    constructor(json?: any) {
        super(json);
    }
}